<template>
  <div id="app">
    <!-- 超时警告提示 -->
    <el-dialog title="会话即将过期" :visible.sync="showInactivityWarning" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <div style="text-align: center; padding: 20px;">
        <i class="el-icon-warning" style="font-size: 48px; color: #E6A23C; margin-bottom: 16px;"></i>
        <p style="font-size: 16px; margin-bottom: 8px;">您的会话将在 <strong style="color: #F56C6C;">{{ remainingTime
        }}</strong> 分钟后过期</p>
        <p style="font-size: 14px; color: #909399;">请点击下方按钮继续使用系统</p>
      </div>
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" @click="resetInactivityTimer" style="width: 120px;">
          继续使用
        </el-button>
      </div>
    </el-dialog>

    <template v-if="$route.path !== '/login'">
      <!-- 头部 -->
      <el-header class="custom-header">
        <div class="header-title">
          <img src="/gps-logo.png" alt="GPS Logo" class="header-logo" />
          <span>经纬财务管理系统</span>
        </div>
        <div class="header-avatar glass" @mouseenter="avatarHover = true" @mouseleave="avatarHover = false"
          :class="{ hover: avatarHover }">
          <el-dropdown @command="handleAvatarCommand" trigger="click" @visible-change="handleDropdownVisibleChange">
            <span class="el-dropdown-link">
              <el-avatar :size="36" class="modern-avatar">
                <span v-if="!userAvatar" v-html="defaultAvatarSvg"></span>
                <img v-else :src="userAvatar" />
              </el-avatar>
              <span class="username">{{ username }}</span>
              <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 24 24">
                <path d="M7 10l5 5 5-5" stroke="#b3c6e0" stroke-width="2" fill="none" stroke-linecap="round" />
              </svg>
            </span>
            <el-dropdown-menu slot="dropdown" class="avatar-dropdown-menu glass-menu">
              <el-dropdown-item command="changePwd" icon="el-icon-lock">修改密码</el-dropdown-item>
              <el-dropdown-item divided command="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 主体内容 -->
      <el-container>
        <!-- 侧边栏 -->
        <el-aside :width="isCollapsed ? '64px' : '200px'" style="background-color: #f5f7fa; transition: width 0.3s ease;">
          <!-- 收放按钮 -->
          <div class="sidebar-toggle" @click="toggleSidebar">
            <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          </div>
          
          <el-menu :default-active="$route.path" router class="el-menu-vertical-demo" 
            background-color="#f5f7fa" text-color="#303133" active-text-color="#409EFF"
            :collapse="isCollapsed" :collapse-transition="true">
            <template v-for="item in visibleMenus">
              <el-submenu v-if="item.children" :index="item.route || item.key" :key="item.key">
                <template slot="title">
                  <i :class="item.icon"></i>
                  <span>{{ item.label }}</span>
                </template>
                <el-menu-item v-for="child in item.children" :index="child.route" :key="child.key">
                  <span slot="title">{{ child.label }}</span>
                </el-menu-item>
              </el-submenu>
              <el-tooltip v-else :content="item.label" placement="right" :disabled="!isCollapsed" :key="item.key">
                <el-menu-item :index="item.route">
                  <i :class="item.icon"></i>
                  <span slot="title">{{ item.label }}</span>
                </el-menu-item>
              </el-tooltip>
            </template>
          </el-menu>
        </el-aside>
        <!-- 内容区域 -->
        <el-container>
          <el-main :style="{ marginLeft: isCollapsed ? '0' : '0' }">
            <!-- 路由出口 -->
            <router-view />
          </el-main>
          <el-footer class="fixed-footer"
            :style="{ left: isCollapsed ? '64px' : '200px', width: isCollapsed ? 'calc(100vw - 64px)' : 'calc(100vw - 200px)' }"
            style="height: 30px; background-color: #f5f7fa; line-height: 30px; text-align: center; color: #909399; transition: all 0.3s ease;">
            经纬财务管理系统 V01版
          </el-footer>
        </el-container>
      </el-container>
    </template>
    <template v-else>
      <router-view />
    </template>

    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="pwdDialogVisible" width="380px" :close-on-click-modal="false"
      class="avatar-dialog" @close="handlePwdDialogClose" :modal="true" :modal-append-to-body="true">
      <el-form :model="pwdForm" :rules="dynamicPwdRules" ref="pwdForm" label-width="80px">
        <el-form-item label="原密码" prop="old_password">
          <el-input v-model="pwdForm.old_password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input v-model="pwdForm.new_password" type="password" autocomplete="off" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirm_password">
          <el-input v-model="pwdForm.confirm_password" type="password" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handlePwdDialogCancel" style="border-radius:18px;">取消</el-button>
        <el-button type="primary" style="background:#409EFF;border:none;border-radius:18px;"
          @click="handleSubmitChangePwd">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { TIMEOUT_CONFIG, getTimeoutMs, getWarningMs } from '@/config/timeout'
// 菜单配置集中管理
const menuList = [
  { key: 'dashboard', label: '数据统计首页', icon: 'el-icon-data-analysis', route: '/dashboard' },
  { key: 'car', label: '车辆信息', icon: 'el-icon-truck', route: '/car' },
  { key: 'company', label: '公司信息', icon: 'el-icon-office-building', route: '/company' },
  { key: 'dailyflow', label: '每日流水', icon: 'el-icon-date', route: '/dailyflow' },
  {
    key: 'customer-service', label: '客服管理', icon: 'el-icon-service', children: [
      { key: 'workorder', label: '工单信息', route: '/customer-service/workorder' },
      { key: 'cancel-order-record', label: '撤单记录', route: '/customer-service/cancel-order-record' },
      { key: 'vehicle-operation', label: '车辆停机/开机操作', route: '/customer-service/vehicle-operation' },
      { key: 'transfer-registration', label: '过户登记', route: '/customer-service/transfer-registration' },
      { key: 'installation-registration', label: '拆装登记', route: '/customer-service/installation-registration' },
      { key: 'card-replacement-registration', label: '车载号码更换登记', route: '/customer-service/card-replacement-registration' },
      { key: 'device-replacement-registration', label: '设备号更换登记', route: '/customer-service/device-replacement-registration' },
      { key: 'salary-slip-query', label: '工资条查询', route: '/customer-service/salary-slip-query' },
      // { key: 'vehicle-card-management', label: '车载卡管理', route: '/customer-service/vehicle-card-management' },
    ]
  },
  {
    key: 'management', label: '管理菜单', icon: 'el-icon-s-tools', children: [
      { key: 'system-type', label: '系统类型管理', route: '/management/system-type' },
      { key: 'order-type', label: '下单类型管理', route: '/management/order-type' },
      { key: 'device-model', label: '设备型号管理', route: '/management/device-model' },
      { key: 'vehicle-type', label: '车辆类型管理', route: '/management/vehicle-type' },
      { key: 'process-type', label: '处理类型管理', route: '/management/process-type' },
      { key: 'payment-type', label: '收费类型管理', route: '/management/payment-type' },
      { key: 'installer', label: '安装师傅管理', route: '/management/installer' },
      { key: 'repair-area', label: '维修区域管理', route: '/management/repair-area' },
      { key: 'user-management', label: '用户管理', route: '/management/user-management' },
      { key: 'log-management', label: '日志管理', route: '/management/log-management' },
    ]
  },
  {
    key: 'statistics', label: '数据统计', icon: 'el-icon-pie-chart', children: [
      { key: 'statement', label: '对账单', route: '/statistics/statement' },
      { key: 'flowstat', label: '流水账单统计', route: '/statistics/flowstat' },
      { key: 'commission-detail', label: '提成明细', route: '/statistics/commission-detail' },
      { key: 'split-vehicle-data', label: '拆分车辆数据', route: '/statistics/split-vehicle-data' }
    ]
  },
  // 库存管理菜单 - 确保key与后端权限组件名称一致
  { key: 'inventory-management', label: '库存管理', icon: 'el-icon-box', route: '/inventory' },
]
export default {
  name: 'App',
  data() {
    return {
      userAvatar: '',
      username: '',
      permissions: {},
      role: '',
      pwdDialogVisible: false,
      pwdForm: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      pwdRules: {
        old_password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '新密码不能少于6位', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请确认新密码', trigger: 'blur' }
        ]
      },
      avatarHover: false,
      defaultAvatarSvg: `<svg width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="#cfd3d6"/><path d="M20 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm0 2c-5.33 0-10 2.67-10 6v2h20v-2c0-3.33-4.67-6-10-6z" fill="#fff"/></svg>`,
      // 自动退出相关
      inactivityTimer: null,
      remainingTime: TIMEOUT_CONFIG.USER_INACTIVITY_TIMEOUT, // 默认30分钟
      showInactivityWarning: false,
      // 侧边栏收放状态
      isCollapsed: false
    }
  },
  computed: {
    visibleMenus() {
      if (this.role === '客服' || this.role === 'customer_service') {
        // 客服用户可以看到的菜单项（不包含车辆信息）
        const customerServiceAllowedKeys = ['company', 'customer-service']
        return menuList.filter(item => customerServiceAllowedKeys.includes(item.key))
      }

      if (this.role === '库存管理员' || this.role === 'inventory_manager') {
        // 库存管理员用户只能看到库存管理菜单
        const inventoryManagerAllowedKeys = ['inventory-management']
        return menuList.filter(item => inventoryManagerAllowedKeys.includes(item.key))
      }

      const allowedKeys = Object.keys(this.permissions)
      if (allowedKeys.length === 0) return menuList

      const self = this
      function filterMenu(list) {
        return list
          .map(item => {
            if (item.children) {
              const children = filterMenu(item.children)
              if (children.length > 0) {
                return { ...item, children }
              }
              return null
            }

            // 检查权限的逻辑优化 - 直接使用 item.key 检查权限
            if (item.key && allowedKeys.includes(item.key) && self.permissions[item.key]?.can_view) {
              return item
            }

            // 库存管理菜单权限检查已通过正常的权限逻辑处理

            return null
          })
          .filter(Boolean)
      }

      return filterMenu(menuList)
    },
    // 动态密码验证规则
    dynamicPwdRules() {
      return {
        old_password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '新密码不能少于6位', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.pwdForm.new_password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    if (localStorage.getItem('access')) {
      this.fetchUserInfo()
    }
    // 恢复侧边栏状态
    const savedState = localStorage.getItem('sidebarCollapsed');
    if (savedState !== null) {
      this.isCollapsed = savedState === 'true';
    }
  },
  mounted() {
    if (localStorage.getItem('access')) {
      this.fetchUserInfo()
      this.startInactivityTimer()
    }
    this.$root.$on('refreshUserInfo', this.fetchUserInfo)
    
    // 添加键盘快捷键监听
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    this.$root.$off('refreshUserInfo', this.fetchUserInfo)
    this.clearInactivityTimer()
    // 移除键盘事件监听
    document.removeEventListener('keydown', this.handleKeydown)
  },
  watch: {
    permissions: {
      handler() {
        // 暂时禁用ensureValidRoute，避免与路由守卫冲突
        // this.ensureValidRoute()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    fetchUserInfo() {
      // 动态获取当前登录用户信息
      request({ url: 'user/info/', method: 'get' })
        .then(res => {
          if (res.data.code === 1) {
            this.username = res.data.data.username || '用户'
            this.permissions = res.data.data.permissions || {}
            this.role = res.data.data.role || ''
            localStorage.setItem('permissions', JSON.stringify(this.permissions))
            localStorage.setItem('role', this.role)

            // 权限信息已获取

            // 已获取用户信息，不需要额外处理
            // 如有头像字段可赋值 this.userAvatar = res.data.data.avatar
            // 拉取完权限后立即校验路由 - 暂时禁用，避免与路由守卫冲突
            // this.ensureValidRoute()
          }
        })
        .catch(() => {
          this.$message.error('获取用户信息失败')
        })
    },
    handleDropdownVisibleChange(visible) {
      console.log('🔧 [DEBUG] 下拉菜单可见性变化:', visible)
    },
    handleAvatarCommand(command) {
      console.log('🔧 [DEBUG] handleAvatarCommand 被调用，command:', command)

      if (command === 'changePwd') {
        console.log('🔧 [DEBUG] 开始处理修改密码命令')

        try {
          // 重置表单数据
          console.log('🔧 [DEBUG] 重置表单数据')
          this.pwdForm = { old_password: '', new_password: '', confirm_password: '' }

          console.log('🔧 [DEBUG] 打开密码对话框')
          this.pwdDialogVisible = true

          console.log('🔧 [DEBUG] 修改密码对话框已打开，pwdDialogVisible:', this.pwdDialogVisible)

          // 检查对话框元素是否存在
          this.$nextTick(() => {
            const dialogElements = document.querySelectorAll('.avatar-dialog')
            console.log('🔧 [DEBUG] 找到的对话框元素数量:', dialogElements.length)

            const elDialogs = document.querySelectorAll('.el-dialog')
            console.log('🔧 [DEBUG] 找到的 el-dialog 元素数量:', elDialogs.length)

            if (elDialogs.length > 0) {
              const lastDialog = elDialogs[elDialogs.length - 1]
              console.log('🔧 [DEBUG] 最后一个对话框的样式:', {
                display: lastDialog.style.display,
                visibility: lastDialog.style.visibility,
                zIndex: lastDialog.style.zIndex,
                position: window.getComputedStyle(lastDialog).position
              })
            }

            // 检查遮罩层
            const masks = document.querySelectorAll('.v-modal')
            console.log('🔧 [DEBUG] 找到的遮罩层数量:', masks.length)
            if (masks.length > 0) {
              const lastMask = masks[masks.length - 1]
              console.log('🔧 [DEBUG] 遮罩层样式:', {
                zIndex: window.getComputedStyle(lastMask).zIndex,
                backgroundColor: window.getComputedStyle(lastMask).backgroundColor,
                opacity: window.getComputedStyle(lastMask).opacity
              })
            }
          })
        } catch (error) {
          console.error('🔧 [ERROR] handleAvatarCommand 出错:', error)
        }
      } else if (command === 'logout') {
        console.log('🔧 [DEBUG] 执行退出登录')
        this.logout()
      }
    },
    handleSubmitChangePwd() {
      console.log('🔧 [DEBUG] 保存按钮被点击')
      console.log('🔧 [DEBUG] 当前组件状态:', {
        pwdDialogVisible: this.pwdDialogVisible,
        hasRefs: !!this.$refs,
        hasPwdForm: !!this.$refs.pwdForm
      })

      try {
        this.submitChangePwd()
      } catch (error) {
        console.error('🔧 [ERROR] handleSubmitChangePwd 调用失败:', error)
        this.$message.error('按钮点击处理失败')
      }
    },
    submitChangePwd() {
      console.log('🔧 [DEBUG] submitChangePwd 方法被调用')
      console.log('🔧 [DEBUG] 当前表单数据:', {
        old_password: this.pwdForm.old_password ? '***' : '空',
        new_password: this.pwdForm.new_password ? '***' : '空',
        confirm_password: this.pwdForm.confirm_password ? '***' : '空'
      })

      try {
        // 基本验证
        console.log('🔧 [DEBUG] 开始基本验证')

        if (!this.pwdForm.old_password) {
          console.log('🔧 [DEBUG] 原密码为空')
          this.$message.warning('请输入原密码')
          return
        }

        if (!this.pwdForm.new_password) {
          console.log('🔧 [DEBUG] 新密码为空')
          this.$message.warning('请输入新密码')
          return
        }

        if (this.pwdForm.new_password.length < 6) {
          console.log('🔧 [DEBUG] 新密码长度不足')
          this.$message.warning('新密码不能少于6位')
          return
        }

        if (!this.pwdForm.confirm_password) {
          console.log('🔧 [DEBUG] 确认密码为空')
          this.$message.warning('请确认新密码')
          return
        }

        if (this.pwdForm.new_password !== this.pwdForm.confirm_password) {
          console.log('🔧 [DEBUG] 两次密码不一致')
          this.$message.warning('两次输入密码不一致')
          return
        }

        console.log('🔧 [DEBUG] 验证通过，准备发送请求')

        // 添加加载状态
        console.log('🔧 [DEBUG] 显示加载状态')
        const loading = this.$loading({
          lock: true,
          text: '正在修改密码...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        console.log('🔧 [DEBUG] 发送修改密码请求')
        console.log('🔧 [DEBUG] request 函数是否存在:', typeof request)

        request({
          url: 'user/change_password/',
          method: 'post',
          data: {
            old_password: this.pwdForm.old_password,
            new_password: this.pwdForm.new_password
          }
        }).then(res => {
          console.log('🔧 [DEBUG] 收到服务器响应:', res.data)
          loading.close()

          if (res.data.code === 1) {
            console.log('🔧 [DEBUG] 密码修改成功')
            this.$message.success('密码修改成功，请重新登录')
            this.pwdDialogVisible = false
            // 清空表单
            this.pwdForm = { old_password: '', new_password: '', confirm_password: '' }
            // 延迟退出，让用户看到成功消息
            console.log('🔧 [DEBUG] 1.5秒后自动退出登录')
            setTimeout(() => {
              this.logout()
            }, 1500)
          } else {
            console.log('🔧 [DEBUG] 密码修改失败:', res.data.msg)
            this.$message.error(res.data.msg || '密码修改失败')
          }
        }).catch(error => {
          console.error('🔧 [ERROR] 修改密码请求失败:', error)
          loading.close()
          this.$message.error('网络请求失败，请检查网络连接')
        })

      } catch (error) {
        console.error('🔧 [ERROR] submitChangePwd 方法执行出错:', error)
        this.$message.error('系统错误，请刷新页面重试')
      }
    },
    handlePwdDialogClose() {
      console.log('🔧 [DEBUG] 密码对话框关闭事件触发')
      try {
        // 对话框关闭时清理表单状态
        this.pwdForm = { old_password: '', new_password: '', confirm_password: '' }
        console.log('🔧 [DEBUG] 表单数据已清理')

        if (this.$refs.pwdForm) {
          this.$refs.pwdForm.clearValidate()
          console.log('🔧 [DEBUG] 表单验证状态已清除')
        }
      } catch (error) {
        console.error('🔧 [ERROR] handlePwdDialogClose 出错:', error)
      }
    },
    handlePwdDialogCancel() {
      console.log('🔧 [DEBUG] 取消按钮被点击')
      try {
        // 取消时关闭对话框
        this.pwdDialogVisible = false
        console.log('🔧 [DEBUG] 对话框已关闭')
      } catch (error) {
        console.error('🔧 [ERROR] handlePwdDialogCancel 出错:', error)
      }
    },
    logout() {
      localStorage.removeItem('access')
      localStorage.removeItem('refresh')
      localStorage.removeItem('permissions')
      localStorage.removeItem('username')
      localStorage.removeItem(TIMEOUT_CONFIG.LAST_ACTIVITY_KEY)
      this.clearInactivityTimer()
      this.$router.replace('/login')
    },
    // 自动退出相关方法
    startInactivityTimer() {
      this.clearInactivityTimer()
      this.remainingTime = TIMEOUT_CONFIG.USER_INACTIVITY_TIMEOUT

      this.inactivityTimer = setInterval(() => {
        const lastActivity = localStorage.getItem(TIMEOUT_CONFIG.LAST_ACTIVITY_KEY)
        if (lastActivity) {
          const now = Date.now()
          const timeDiff = now - parseInt(lastActivity)
          const timeoutMs = getTimeoutMs()
          const remainingMs = timeoutMs - timeDiff

          if (remainingMs <= 0) {
            // 超时，自动退出
            this.$message.warning('由于长时间未操作，系统已自动退出登录')
            this.logout()
          } else if (remainingMs <= getWarningMs()) { // 剩余5分钟时显示警告
            this.remainingTime = Math.ceil(remainingMs / 60000)
            this.showInactivityWarning = true
          }
        }
      }, TIMEOUT_CONFIG.CHECK_INTERVAL) // 每分钟检查一次
    },
    clearInactivityTimer() {
      if (this.inactivityTimer) {
        clearInterval(this.inactivityTimer)
        this.inactivityTimer = null
      }
      this.showInactivityWarning = false
    },
    resetInactivityTimer() {
      localStorage.setItem(TIMEOUT_CONFIG.LAST_ACTIVITY_KEY, Date.now().toString())
      this.showInactivityWarning = false
      this.remainingTime = TIMEOUT_CONFIG.USER_INACTIVITY_TIMEOUT
    },
    ensureValidRoute() {
      // 只在非登录页面且已登录的情况下才进行路由校验
      if (this.$route.path === '/login' || !localStorage.getItem('access')) {
        return
      }

      // 获取所有有权限的路由
      const getFirstRoute = (menus) => {
        for (const item of menus) {
          if (item.children && item.children.length > 0) {
            const childRoute = getFirstRoute(item.children)
            if (childRoute) return childRoute
          } else if (item.route) {
            return item.route
          }
        }
        return null
      }
      const firstRoute = getFirstRoute(this.visibleMenus)

      // 收集所有有权限的路由
      const allRoutes = []
      const collectRoutes = (menus) => {
        for (const item of menus) {
          if (item.children && item.children.length > 0) {
            collectRoutes(item.children)
          } else if (item.route) {
            allRoutes.push(item.route)
          }
        }
      }
      collectRoutes(this.visibleMenus)

      // 如果当前路由不在可见菜单内，且不是根路径，才进行跳转
      // 添加防护措施避免无限重定向
      if (allRoutes.length && !allRoutes.includes(this.$route.path) && firstRoute && this.$route.path !== '/') {
        // 使用nextTick确保DOM更新完成后再进行路由跳转
        this.$nextTick(() => {
          this.$router.replace(firstRoute)
        })
      }
    },
    // 切换侧边栏收放状态
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
      // 保存状态到localStorage
      localStorage.setItem('sidebarCollapsed', this.isCollapsed.toString());
    },
    // 处理键盘快捷键
    handleKeydown(event) {
      // Ctrl+B 切换侧边栏
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault();
        this.toggleSidebar();
      }
    }
  }
}
</script>

<style>
#app,
.el-container {
  height: 100vh;
}

.el-aside {
  height: 100vh;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.el-header {
  padding: 0;
}

.el-aside {
  border-right: 1px solid #e6e6e6;
}

.el-main {
  padding: 20px;
  background-color: #f0f2f5;
}

.el-menu-vertical-demo {
  border-right: none;
}

.el-menu-item,
.el-submenu__title {
  height: 50px;
  line-height: 50px;
}

.el-menu-item:hover,
.el-submenu__title:hover {
  background-color: #ecf5ff !important;
}

.el-menu-item.is-active {
  background-color: #ecf5ff !important;
  color: #409EFF !important;
}

.fixed-footer {
  position: fixed;
  left: 200px;
  bottom: 0;
  width: calc(100vw - 200px);
  z-index: 200;
  background: #f5f7fa;
  box-shadow: 0 -2px 8px #eee;
  transition: all 0.3s ease;
}

.custom-header {
  height: 70px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  box-sizing: border-box;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}

.custom-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  backdrop-filter: blur(10px);
  z-index: 1;
}

.custom-header>* {
  position: relative;
  z-index: 2;
}

.header-title {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #fff;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Logo 样式 - 圆形设计 */
.header-logo {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  padding: 2px;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-logo:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.header-avatar {
  position: relative;
  min-width: 180px;
  height: 48px;
  display: flex;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 24px;
  padding: 0 20px 0 8px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 10;
}

.header-avatar.glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
}

.header-avatar.hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.header-avatar .el-dropdown-link {
  display: flex;
  align-items: center;
}

.header-avatar .username {
  margin-left: 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-avatar:hover .username {
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.header-avatar .dropdown-arrow {
  margin-left: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.8;
}

.header-avatar .dropdown-arrow path {
  stroke: rgba(255, 255, 255, 0.8);
  transition: stroke 0.3s ease;
}

.header-avatar:hover .dropdown-arrow {
  opacity: 1;
  transform: translateY(1px);
}

.header-avatar:hover .dropdown-arrow path {
  stroke: #fff;
}

.header-avatar.hover .dropdown-arrow {
  transform: rotate(180deg) translateY(-1px);
}

.avatar-dropdown-menu.glass-menu {
  border-radius: 16px !important;
  min-width: 150px;
  box-shadow: 0 8px 32px rgba(64, 158, 255, 0.18);
  padding: 8px 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 80%, rgba(64, 158, 255, 0.08));
  backdrop-filter: blur(6px);
  border: none;
}

.avatar-dropdown-menu .el-dropdown-menu__item {
  font-size: 15px;
  padding: 12px 28px 12px 22px;
  border-radius: 8px;
  margin: 2px 8px;
  transition: background 0.2s, color 0.2s;
}

.avatar-dropdown-menu .el-dropdown-menu__item i {
  margin-right: 10px;
  color: #409EFF;
}

.avatar-dropdown-menu .el-dropdown-menu__item:hover {
  background: #e3f0ff !important;
  color: #409EFF !important;
}

.avatar-dialog .el-dialog__wrapper {
  z-index: 2000 !important;
}

.avatar-dialog .el-dialog {
  margin-top: 15vh !important;
  border-radius: 16px;
  overflow: hidden;
}

.avatar-dialog .el-dialog__header {
  background: #f5faff;
  border-radius: 14px 14px 0 0;
  padding: 20px 24px 16px 24px;
}

.avatar-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.avatar-dialog .el-dialog__body {
  padding: 20px 24px;
}

.avatar-dialog .el-dialog__footer {
  padding: 16px 24px 20px 24px;
  text-align: center;
}

.avatar-dialog .el-form-item__label {
  color: #409EFF;
  font-weight: 500;
}

.avatar-dialog .el-input__inner {
  border-radius: 8px;
  border: 2px solid #e1e8ed;
  padding: 12px 16px;
  transition: all 0.3s ease;
}

.avatar-dialog .el-input__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}

.avatar-dialog .el-button {
  border-radius: 18px;
  padding: 12px 24px;
  font-weight: 500;
  min-width: 80px;
}

/* 现代头像样式 */
.modern-avatar {
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.header-avatar:hover .modern-avatar {
  border-color: rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
  transform: scale(1.05);
}

/* 优化默认头像SVG */
.modern-avatar .el-avatar__inner {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
}

/* 修复遮罩层问题 */
.v-modal {
  z-index: 1999 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

/* 侧边栏收放按钮样式 */
.sidebar-toggle {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e3f2fd 100%);
  border-bottom: 1px solid #e1e8ed;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #606266;
  font-size: 18px;
  position: relative;
  overflow: hidden;
}

.sidebar-toggle::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(64, 158, 255, 0.1), transparent);
  transition: left 0.5s ease;
}

.sidebar-toggle:hover {
  background: linear-gradient(135deg, #ecf5ff 0%, #e3f2fd 100%);
  color: #409EFF;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
}

.sidebar-toggle:hover::before {
  left: 100%;
}

.sidebar-toggle:active {
  transform: scale(0.98);
}

/* 侧边栏过渡效果 */
.el-aside {
  transition: width 0.3s ease !important;
}

/* 菜单收起时的样式调整 */
.el-menu--collapse {
  width: 64px;
}

.el-menu--collapse .el-menu-item,
.el-menu--collapse .el-submenu__title {
  padding: 0 20px !important;
  text-align: center;
}

.el-menu--collapse .el-menu-item [class^="el-icon-"],
.el-menu--collapse .el-submenu__title [class^="el-icon-"] {
  margin: 0;
  vertical-align: middle;
  width: 24px;
  text-align: center;
}

.el-menu--collapse .el-menu-item .el-tooltip,
.el-menu--collapse .el-submenu__title .el-tooltip {
  padding: 0 20px;
}

/* 收起状态下的子菜单弹出样式 */
.el-menu--collapse .el-submenu .el-menu {
  position: absolute;
  margin-left: 5px;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 99;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar-toggle {
    height: 45px;
    font-size: 16px;
  }
  
  .el-aside {
    position: fixed !important;
    left: 0;
    top: 70px;
    height: calc(100vh - 70px) !important;
    z-index: 1000;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
  }
  
  .el-main {
    margin-left: 0 !important;
    padding-left: 20px;
  }
  
  .fixed-footer {
    left: 0 !important;
    width: 100vw !important;
  }
}

/* Tooltip样式优化 */
.el-tooltip__popper {
  background: #303133 !important;
  color: #fff !important;
  border-radius: 6px !important;
  font-size: 12px !important;
  padding: 8px 12px !important;
}

.el-tooltip__popper .popper__arrow {
  border-right-color: #303133 !important;
}
</style>